import {
    ProjectContainer,
    ProjectCard,
    CardContainer,
    ProjectDetails,
    ProjectDetails2,
    ProjectHeading,
    ProjectSummary,
    ImageContainer,
    ImageContainer2,
    ProjectLink,
    ProjectImage,
    LargeDeviceContainer
} from './styledComponents'
import {CiShare1} from 'react-icons/ci'


const Projects = ()=>{
    return(
        <ProjectContainer id="projectSection">
            <LargeDeviceContainer>
            <CardContainer>
            <ProjectCard>
                <ProjectDetails>
                    <ProjectHeading>
                        Hostel Management System
                    </ProjectHeading>
                    <ProjectSummary>
                    Developed web-based Full Stack Hostel Management System, built with React.js on the front end and Node.js on the backend, simplifies hostel operations. It offers real-time room availability tracking across individual rooms and floors, facilitates student information management (including registration, details, and potentially room assignments), and implements a secure multi-level user access control system with roles like Admin and Super Admin. This centralized platform streamlines hostel resource management, and student data handling, and improves overall efficiency and transparency.
                    </ProjectSummary>
                    <ProjectLink href="https://github.com/manicharan-12/Hostel-Management-System" target='_blank'>Hostel Management <CiShare1/></ProjectLink>
                </ProjectDetails>
                <ImageContainer>
                    <ProjectImage src="https://res.cloudinary.com/djovsq3xl/image/upload/v1712157176/hostel-management-1-removebg-preview_uvwsuz.png" alt="Jobby App"/>
                </ImageContainer>
            </ProjectCard>
            <ProjectCard>
                <ImageContainer>
                    <ProjectImage src="https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png" alt="Jobby App"/>
                </ImageContainer>
                <ProjectDetails>
                    <ProjectHeading>
                        Nxt Watch
                    </ProjectHeading>
                    <ProjectSummary>
                    Built the Nxt Watch application, modelled after YouTube, enabling users to log in, explore video categories
such as Trending and Gaming, access saved videos, and search for specific content while adjusting the interface
theme.
                    </ProjectSummary>
                    <ProjectLink href="https://mcnxtwatch.ccbp.tech/" target='_blank'>Nxt Watch <CiShare1/></ProjectLink>
                </ProjectDetails>
            </ProjectCard>
            <ProjectCard>
                <ProjectDetails>
                    <ProjectHeading>
                        Jobby App
                    </ProjectHeading>
                    <ProjectSummary>
                    Developed a comprehensive job search solution, Jobby App, using React.js. Designed pages for Login, Home, Jobs, and Job item details with React components and form inputs.
                    Secured user data with JWT tokens, REST API calls, and local storage. Implemented protected routes and persisted login state with React Router and local storage.
                    </ProjectSummary>
                    <ProjectLink href="https://mcjobbyapp.ccbp.tech/" target='_blank'>Jobby App <CiShare1/></ProjectLink>
                </ProjectDetails>
                <ImageContainer>
                    <ProjectImage src="https://assets.ccbp.in/frontend/react-js/logo-img.png" alt="Jobby App"/>
                </ImageContainer>
            </ProjectCard>
            <ProjectCard>
            <ImageContainer>
                    <ProjectImage src="https://assets.ccbp.in/frontend/react-js/nxt-trendz-logo-img.png" alt="Nxt Trendz"/>
                </ImageContainer>
                <ProjectDetails>
                    <ProjectHeading>
                        Nxt Trendz
                    </ProjectHeading>
                    <ProjectSummary>
                    Project is to implement Nxt Trendz, an e-commerce platform inspired by Amazon and Flipkart. I have developed cutting-edge features such as login, product pages, and product details. I used React Router, React components, form inputs, and event handlers to build these pages. I also enabled secure authentication and authorization with JWT tokens and REST API calls.
                    </ProjectSummary>
                    <ProjectLink href="https://mcnxtrendz.ccbp.tech/" target='_blank'>Nxt Trendz <CiShare1/></ProjectLink>
                </ProjectDetails>
            </ProjectCard>
            </CardContainer>
            </LargeDeviceContainer>
        </ProjectContainer>

    )
}

export default Projects
